import { Box, Grid, Tooltip } from "@mui/material";
import InfoSection  from "./InfoSection";
import { useTranslation } from "react-i18next";

type AddonsCardProps = {
  data: any;
};

function AddonsCard({
  data
}: AddonsCardProps) {
  const { t } = useTranslation();

  return (
    <Box
      component="div"
      sx={{
        backgroundColor: "var(--color-gray-light)",
        minHeight: "100px",
        marginX: "auto",
        paddingY: "9px",
        borderRadius: "15px",
        paddingX: "24px",
        display: 'flex',
        alignItems: 'center'
      }}
    >
      <Grid container sx={{ height: "100%", alignItems: "flex-start" }}>
        <Grid
          item
          xs={12}
          sm={12}
          md={5}
          display={"flex"}
          alignItems={"space-between"}
          justifyContent={"center"}
          flexDirection={"column"}
          rowGap={1.4}
        >
          <InfoSection
            title={`${t("name")} :`}
            value={data?.Name}
            doNotChangeCase={true}
          />
           <InfoSection
            title={`${t("size")} :`}
            value={data?.Size}
            doNotChangeCase={true}
          />
          <InfoSection
            title={`${t("quantity")} :`}
            value={data?.Quantity}
          />
          
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={7}
          display={"flex"}
          alignItems={"space-between"}
          justifyContent={"center"}
          flexDirection={"column"}
          rowGap={1.4}
        >
        <InfoSection title={`${t("notes")} :`} value={
           <Tooltip
           title={data?.Notes}
           placement="top"
           slotProps={{
             popper: {
               modifiers: [
                 {
                   name: 'offset',
                   options: {
                     offset: [0, -14],
                   },
                 },
               ],
             },
           }}

         >
          {data?.Notes?.length > 25 ? `${data?.Notes?.substring(0, 25)}...` : data?.Notes}
          </Tooltip>
          
          } />
         <InfoSection
            title={`${t("description")} :`}
            value={
              <Tooltip
                title={data?.Description}
                placement="top"
                slotProps={{
                  popper: {
                    modifiers: [
                      {
                        name: 'offset',
                        options: {
                          offset: [0, -14],
                        },
                      },
                    ],
                  },
                }}
              >
                {data?.Description?.length > 25 ? `${data?.Description?.substring(0, 25)}...` : data?.Description}
              </Tooltip>
            }
            doNotChangeCase={true}
          />
         
        </Grid>
   
      </Grid>
    </Box>
  );
}

export default AddonsCard;
